module.exports = __webpack_public_path__ + "static/media/report-frequency-icon.943ea897.svg";